/**
 * @generated SignedSource<<cf629b17227e1468aefd044e539578df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type homeRecommendedForYouSponsorArticleQueueItemsEdge$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"homeNativeArticleContentItemContent">;
  };
  readonly " $fragmentType": "homeRecommendedForYouSponsorArticleQueueItemsEdge";
};
export type homeRecommendedForYouSponsorArticleQueueItemsEdge$key = {
  readonly " $data"?: homeRecommendedForYouSponsorArticleQueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"homeRecommendedForYouSponsorArticleQueueItemsEdge">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "homeRecommendedForYouSponsorArticleQueueItemsEdge"
};

(node as any).hash = "6dd4a8fa8aba9333f1d0ea886fbb7bac";

export default node;
